export default (size) => {
    if (size < 1024) {
        return size + ' B';
    }

    const i = Math.floor(Math.log(size) / Math.log(1024));
    const num = size / Math.pow(1024, i);
    const round = Math.round(num);
    const float = String(round < 10 ? num.toFixed(2) : round < 100 ? num.toFixed(1) : round).replace(/\.0+$/, '');
    const quants = 'KMGTPEZY';
    const bracket = quants[i - 1];

    return `${float} ${bracket}B`;
};
